import { z } from 'zod';
import { createSortablePaginationSchema } from '../shared/index.js';
/**
 * Entity types that can have comments attached to them
 */
export var CommentEntityType;
(function (CommentEntityType) {
    CommentEntityType["LEGISLATIVE_ITEM"] = "legislative_item";
})(CommentEntityType || (CommentEntityType = {}));
/**
 * Schema for creating a new comment
 */
export const createCommentSchema = z.object({
    message: z
        .string('Message is required')
        .min(1, 'Message is required')
        .max(4000, 'The message is too long'),
});
/**
 * Schema for updating an existing comment
 */
export const updateCommentSchema = z.object({
    message: z
        .string('Message is required')
        .min(1, 'Message is required')
        .max(4000, 'The message is too long'),
});
/**
 * Schema for querying comments with pagination
 */
export const commentsQueryParamsSchema = createSortablePaginationSchema(['createdAt', 'id']);
